export default "__VITE_ASSET__415cc64d__"